var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Proedit',{attrs:{"value":_vm.value,"compact":""},on:{"changer":function($event){return _vm.$emit('changer', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }